import * as $ from "jquery";
import ContactFormFields from "../Fields/ContactFormFields";
import {calculateWindowOffset} from "../../Functions/CalculateWindowOffset";
import {onLoad, onClick, onChange, onKeyUp} from "Core/Events";
import ReCaptchaValidation from "Components/Validation/ReCaptchaValidation";
import {initReCaptcha} from "../../Functions/InitReCaptcha";

export const ContactFormValidation = (() => {
    const Selector = {
        FORM: '#contact-form',
        FORM_INPUTS: '#contact-form .form-control',
        SUBMIT_BUTTON: '#contact-submit',
        RECAPTCHA: '#contact-form #g-recaptcha',
        RECAPTCHA_ERROR_MSG: '#contact-form .g-recaptcha-error',
    };

    onLoad(initReCaptcha(Selector.RECAPTCHA));
    onChange(Selector.FORM_INPUTS, validateFormFields)
    onKeyUp(Selector.FORM_INPUTS, validateFormFields)
    onClick(Selector.SUBMIT_BUTTON, submitContactForm);

    function submitContactForm() {
        if (validateAllForm()) {
            $(Selector.FORM).submit()
        }
    }

    function validateFormFields() {
        validateFormFieldsJquery();
    }

    function validateAllForm() {
        validateFormFieldsJquery();

        let formIsValid = $(Selector.FORM).valid();
        let recaptchaIsChecked = ReCaptchaValidation.validate(Selector.RECAPTCHA, Selector.RECAPTCHA_ERROR_MSG);

        return formIsValid && recaptchaIsChecked;
    }

    function validateFormFieldsJquery() {
        $(Selector.FORM).validate({
            ignore: '',
            rules: ContactFormFields.getFields(Selector),
            messages: {
                'contact[email]': {
                    require_from_group: $.validator.messages.required_from_group,
                },
                'contact[phone]': {
                    require_from_group: $.validator.messages.required_from_group,
                }
            },
            errorPlacement: function (error, element) {
                $(element).parent().append(error)
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids())
                    return;

                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - calculateWindowOffset()
                }, 600);
            }
        });
    }

    return true;
})();
import * as $ from "jquery";
import ContactFormFields from "../Fields/ContactFormFields";
import {calculateWindowOffset} from "../../Functions/CalculateWindowOffset";
import {onLoad, onClick, onChange, onKeyUp} from "Core/Events";
import ReCaptchaValidation from "Components/Validation/ReCaptchaValidation";
import {initReCaptcha} from "../../Functions/InitReCaptcha";

export const ContactFormValidation = (() => {
    const Selector = {
        FORM: '#contact-form',
        FORM_INPUTS: '#contact-form .form-control',
        SUBMIT_BUTTON: '#contact-submit',
        RECAPTCHA: '#contact-form #g-recaptcha',
        RECAPTCHA_ERROR_MSG: '#contact-form .g-recaptcha-error',
    };

    onLoad(initReCaptcha(Selector.RECAPTCHA));
    onChange(Selector.FORM_INPUTS, validateFormFields)
    onKeyUp(Selector.FORM_INPUTS, validateFormFields)
    onClick(Selector.SUBMIT_BUTTON, submitContactForm);

    function submitContactForm() {
        if (validateAllForm()) {
            $(Selector.FORM).submit()
        }
    }

    function validateFormFields() {
        validateFormFieldsJquery();
    }

    function validateAllForm() {
        validateFormFieldsJquery();

        let formIsValid = $(Selector.FORM).valid();
        let recaptchaIsChecked = ReCaptchaValidation.validate(Selector.RECAPTCHA, Selector.RECAPTCHA_ERROR_MSG);

        return formIsValid && recaptchaIsChecked;
    }

    function validateFormFieldsJquery() {
        $(Selector.FORM).validate({
            ignore: '',
            rules: ContactFormFields.getFields(Selector),
            messages: {
                'contact[email]': {
                    require_from_group: $.validator.messages.required_from_group,
                },
                'contact[phone]': {
                    require_from_group: $.validator.messages.required_from_group,
                }
            },
            errorPlacement: function (error, element) {
                $(element).parent().append(error)
            },
            invalidHandler: function (form, validator) {
                if (!validator.numberOfInvalids())
                    return;

                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element).offset().top - calculateWindowOffset()
                }, 600);
            }
        });
    }

    return true;
})();
